import { useParams } from 'react-router-dom';
import { MyOrderCartList } from './MyOrderCartList';

export const MyOrderCartListView = () => {
    const { cartRefNo } = useParams();
    if (!cartRefNo) return null;

    return <MyOrderCartList cartRefNo={cartRefNo} />;
};
